import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: transparent;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 20px 0;
    gap: 20px;
  }
`;

export const NotFoundListingSearchBannerWrapper = styled.div`
  margin: 0 8px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 0;
  }
`;

export const PopularDomesticToursList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 114px;
  grid-auto-rows: 114px;
  gap: 8px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 200px;
    grid-auto-rows: 200px;
    gap: 12px;
  }
`;

export const PopularAbroadToursList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 167px;
  grid-auto-rows: 167px;
  gap: 8px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 295px;
    grid-auto-rows: 295px;
    gap: 12px;
  }
`;
